/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".pdf-viewer[_ngcontent-%COMP%]{margin-top:1rem;width:100%;height:80vh}"];
export { styles as styles };

